import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Search, User, ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'MENU', path: '/menu' },
    { name: 'SHAWARMA', path: '/menu?category=shawarma' },
    { name: 'SNACKS', path: '/menu?category=snacks' },
    { name: 'DRINKS', path: '/menu?category=drinks' },
    { name: 'BOOK SEAT', path: '/book-seat' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* Top Header Strip */}
      <div className="bg-muted border-b border-border">
        <div className="section-container">
          <div className="flex justify-between items-center py-2 text-xs sm:text-sm">
            <p className="text-muted-foreground">Welcome to Insta Cafe!</p>
            <div className="flex items-center gap-4 text-muted-foreground">
              <span>Currency: INR</span>
              <span>Language: EN</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-card border-b border-border sticky top-0 z-40 shadow-cafe-sm">
        <div className="section-container">
          {/* Top section with support, logo, user */}
          <div className="flex justify-between items-center py-4">
            {/* Customer Support */}
            <div className="hidden lg:flex items-center gap-2">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <Phone className="w-5 h-5 text-primary-foreground" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Customer Support</p>
                <a href="tel:09994520043" className="text-sm font-medium text-foreground hover:text-primary">
                  099945 20043
                </a>
              </div>
            </div>

            {/* Logo */}
            <Link to="/" className="flex items-center gap-3">
              <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center overflow-hidden">
                <img src="/favicon.png" alt="Insta Cafe Logo" className="w-full h-full object-cover" />
              </div>
              <div>
                <h1 className="text-2xl sm:text-3xl font-display font-bold text-primary">INSTA CAFE</h1>
                <p className="text-xs text-muted-foreground hidden sm:block">Fresh • Tasty • Insta-worthy</p>
              </div>
            </Link>

            {/* Right Actions */}
            <div className="flex items-center gap-2">
              <Button
                variant="ghost"
                size="icon"
                className="hidden sm:flex"
                onClick={() => setSearchOpen(!searchOpen)}
              >
                <Search className="w-5 h-5" />
              </Button>
              <Button variant="ghost" size="icon" className="hidden sm:flex">
                <User className="w-5 h-5" />
              </Button>
              <Button variant="ghost" size="icon" className="lg:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </Button>
            </div>
          </div>

          {/* Search Bar */}
          {searchOpen && (
            <div className="pb-4">
              <div className="relative max-w-md ml-auto">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input
                  type="text"
                  placeholder="Search menu items..."
                  className="pl-10"
                />
              </div>
            </div>
          )}

          {/* Navigation */}
          <nav className="hidden lg:block border-t border-border">
            <ul className="flex items-center justify-center gap-8 py-4">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className={`text-sm font-medium transition-colors hover:text-primary ${isActive(link.path) ? 'text-primary' : 'text-foreground'
                      }`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-border bg-card">
            <nav className="section-container py-4">
              <ul className="space-y-3">
                {navLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      onClick={() => setMobileMenuOpen(false)}
                      className={`block py-2 text-sm font-medium transition-colors hover:text-primary ${isActive(link.path) ? 'text-primary' : 'text-foreground'
                        }`}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="mt-4 pt-4 border-t border-border">
                <a href="tel:09994520043" className="flex items-center gap-2 text-sm">
                  <Phone className="w-4 h-4" />
                  <span>099945 20043</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;